import React from "react";
import Services from "../Services";
import AppContext from "../contexts/AppContext";
import {Router, RenderCurrentRoute} from "@morningtrain/react-navigation";
import Page from "../Page";

export default function App(props) {

    const global = window || global;
    const app = global.app;

    return (
        <AppContext.Provider value={app}>
            <Router components={app.components} >
                <Services global={true} >
                    <Page>
                        <RenderCurrentRoute />
                    </Page>
                </Services>
            </Router>
        </AppContext.Provider>
    );
}
